import { get, merge } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { REDUCER } from 'constants/entity-names';
import { getStore } from 'store';
import { getVisibleItems } from 'resolvers/getVisibleEntities';

// get store
const store = getStore();

/*************************************************************/

/**
 * @type {class}
 * @desc MemberDetailsSavingsWidget defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberDetailsSavingsWidgetService } from 'services/memberDetailsSavingsWidget';
 *
 * // create service instance and send/cancel request
 * const MemberDetailsSavingsWidgetService = new MemberDetailsSavingsWidgetService();
 * const result = await MemberDetailsSavingsWidgetService.fetchData( '<user-id>' ); // fetch data
 * MemberDetailsSavingsWidgetService.cancel(); // cancel an active request
 */

export class MemberDetailsSavingsWidgetService extends HttpService {

    // make request and fetch component data
    async fetchComponentData( { url = {}, data = {}, memberId = {} } = {} ) {

        // get ongoing call info from the redux store
        const callId = get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null );

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: merge( data, {
                    context: {
                        callId,
                        memberId
                    }
                } ),
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    title: get( response, 'body.component.structure.title', {} ),
                    balanceAndSavings: get( response, 'body.component.data.state', {} ),
                    cards: get( response, 'body.component.structure.cards', [] ),
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    async fetchAlternateDrugsData( { url, data, memberId  } ) {

        // get ongoing call info from the redux store
        const callId = get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null );

        const response = await this.post( {
            host: CONFIG.host,
            path: url,
            data: merge( data, {
                context: {
                    callId,
                    memberId
                }
            } ),
        } );

        // extract component data
        const visibility = get( response, 'body.component.visibility', {} );
        const tabs = get( response, 'body.component.structure.tabs', [] );
        const title = get( response, 'body.component.structure.title', {} );

        return {
            status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
            data: {
                tabs: getVisibleItems( tabs, visibility ),
                title: title,
            },
        };
    }
}
